var _circle, _circle2, _circle3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNegativeSmile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#FF6161"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2222,
    cy: 14.2222,
    r: 2.22222,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.7779,
    cy: 14.2222,
    r: 2.22222,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5311 27.5909C25.3225 27.7173 25.0828 27.7832 24.8388 27.7813C24.5955 27.7859 24.3556 27.7238 24.1451 27.6018C23.9346 27.4797 23.7615 27.3024 23.6446 27.089C23.0348 26.0361 22.159 25.1621 21.1049 24.5545C20.0508 23.9469 18.8555 23.627 17.6388 23.627C16.4221 23.627 15.2269 23.9469 14.1728 24.5545C13.1187 25.1621 12.2428 26.0361 11.6331 27.089C11.5505 27.2611 11.4332 27.4143 11.2886 27.539C11.1439 27.6636 10.9751 27.757 10.7926 27.8133C10.6101 27.8696 10.418 27.8875 10.2283 27.8659C10.0386 27.8444 9.85538 27.7838 9.69019 27.688C9.525 27.5923 9.3814 27.4634 9.26842 27.3095C9.15544 27.1555 9.07551 26.9799 9.03366 26.7936C8.99182 26.6073 8.98895 26.4144 9.02525 26.2269C9.06155 26.0395 9.13623 25.8616 9.24459 25.7043C10.0952 24.2307 11.3188 23.007 12.7923 22.1562C14.2658 21.3053 15.9373 20.8574 17.6388 20.8574C19.3403 20.8574 21.0119 21.3053 22.4854 22.1562C23.9589 23.007 25.1824 24.2307 26.033 25.7043C26.2155 26.0213 26.2652 26.3977 26.1711 26.7511C26.0771 27.1046 25.847 27.4065 25.5311 27.5909Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegativeSmile);
export default __webpack_public_path__ + "static/media/negative-smile.68b79bce234b8812955b719a3b9a3363.svg";
export { ForwardRef as ReactComponent };